import AdminPortalFrame from './src/AdminPortalFrame'

export default AdminPortalFrame
